// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1B5CL","tab":"ProcedureTabs_tab__30z9B"};